import { Component, OnInit, Input } from '@angular/core';
import { LocalPagingFilter } from '../../../core/services/filtering.service';

@Component({
  selector: 'app-grid-loader',
  templateUrl: './grid-loader.component.html',
  styleUrls: ['./grid-loader.component.scss']
})
export class GridLoaderComponent implements OnInit {

  @Input()
  public paging: LocalPagingFilter;

  constructor() { }

  public ngOnInit() {
  }

}
